import { type ReactNode } from 'react';

/** Optional page intro under the top-bar title. Prefer description/actions only on list pages. */
export function PageHeader(props: {
  title?: string | undefined;
  description?: string | undefined;
  badge?: ReactNode;
  actions?: ReactNode;
}) {
  const hasTitle = Boolean(props.title);
  if (!hasTitle && !props.description && !props.actions && !props.badge) return null;

  return (
    <div className="admin-page-header flex flex-wrap items-end justify-between gap-5">
      <div className="min-w-0">
        {hasTitle ? (
          <div className="flex flex-wrap items-center gap-3">
            <h2 className="admin-display truncate text-2xl font-semibold text-slate-900 dark:text-slate-100">
              {props.title}
            </h2>
            {props.badge}
          </div>
        ) : props.badge ? (
          <div>{props.badge}</div>
        ) : null}
        {props.description ? (
          <p
            className={
              hasTitle
                ? 'mt-1.5 max-w-2xl text-sm leading-relaxed text-slate-500 dark:text-slate-400'
                : 'max-w-2xl text-sm leading-relaxed text-slate-500 dark:text-slate-400'
            }
          >
            {props.description}
          </p>
        ) : null}
      </div>
      {props.actions ? (
        <div className="flex flex-wrap items-center justify-end gap-2">{props.actions}</div>
      ) : null}
    </div>
  );
}
